module.exports = __webpack_public_path__ + "img/volume-up.3f378c8a.svg";